import React, { useState, useCallback } from 'react'

import { Grid } from '@material-ui/core'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import Switch from 'shared/components/Switch'
import { colors } from 'shared/styles/colors'

import Modal from '../../../../../shared/components/Modal'
import { IDetalhesProps } from './DetalhesComponent.types'
import { Title, Field, Value, Label, StyledContainerSwitch } from './styles'

export const DetalhesCaminhao: React.FC<IDetalhesProps> = ({
  caminhao,
  openModal,
  checked,
  onCloseModal,
  onChangeSituacaoCaminhao,
}) => {
  const [loading, setLoading] = useState(false)

  const handleChangeStatus = useCallback(async () => {
    setLoading(true)

    try {
      await onChangeSituacaoCaminhao(caminhao)
      setLoading(false)
    } catch (e) {
      setLoading(false)
    }
  }, [caminhao, onChangeSituacaoCaminhao])

  return (
    <>
      <Modal
        openModal={openModal}
        showCloseButton={true}
        size="large"
        onCloseModal={onCloseModal}
      >
        <StyledContainerSwitch>
          <Label>Status</Label>
          <Switch id="status" checked={checked} onChange={handleChangeStatus} />
        </StyledContainerSwitch>
        <Grid container spacing={3}>
          <Grid container>
            <Grid item xs={12}>
              <Title style={{ marginTop: '30px' }}>Dados cavalo</Title>
            </Grid>

            <Grid item xs={3}>
              <Field>Placa do cavalo</Field>
            </Grid>
            <Grid item xs={3}>
              <Field>RENAVAM</Field>
            </Grid>
            <Grid item xs={3}>
              <Field>Local de emissão</Field>
            </Grid>
            <Grid item xs={3}>
              <Field>CNPJ</Field>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={3}>
              <Value>{caminhao?.veiculoCavalo?.placa}</Value>
            </Grid>
            <Grid item xs={3}>
              <Value>{caminhao?.veiculoCavalo?.renavam}</Value>
            </Grid>
            <Grid item xs={3}>
              <Value>{caminhao?.veiculoCavalo?.local_emissao}</Value>
            </Grid>
            <Grid item xs={3}>
              <Value>{caminhao?.veiculoCavalo?.frotista.cnpj}</Value>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={3}>
              <Field>País</Field>
            </Grid>
            <Grid item xs={3}>
              <Field>Padrão MERCOSUL</Field>
            </Grid>
            <Grid item xs={3}>
              <Field>Chassi</Field>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={3}>
              <Value>BRASIL</Value>
            </Grid>
            <Grid item xs={3}>
              <Value>
                {caminhao?.veiculoCavalo.placa
                  ? (caminhao?.veiculoCavalo.placa.match(/\d/g) || []).length >
                    3
                    ? 'INATIVO'
                    : 'ATIVO'
                  : ' '}
              </Value>
            </Grid>
            <Grid item xs={3}>
              <Value>{caminhao?.veiculoCavalo.chassi}</Value>
            </Grid>
          </Grid>

          {caminhao?.veiculoCarreta1 && (
            <>
              <Grid container>
                <Grid item xs={12}>
                  <Title>Dados carreta 1</Title>
                </Grid>

                <Grid item xs={4}>
                  <Field>Placa do cavalo</Field>
                </Grid>
                <Grid item xs={4}>
                  <Field>Tipo de carreta</Field>
                </Grid>
                <Grid item xs={4}>
                  <Field>CNPJ</Field>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={4}>
                  <Value>{caminhao?.veiculoCarreta1?.placa}</Value>
                </Grid>
                <Grid item xs={4}>
                  <Value>
                    {caminhao?.veiculoCarreta1?.tipoCarreta?.descricao}
                  </Value>
                </Grid>
                <Grid item xs={4}>
                  <Value>{caminhao.veiculoCarreta1?.frotista?.cnpj}</Value>
                </Grid>
              </Grid>
            </>
          )}

          {caminhao?.veiculoCarreta2 && (
            <>
              <Grid container>
                <Grid item xs={12}>
                  <Title>Dados carreta 2</Title>
                </Grid>

                <Grid item xs={4}>
                  <Field>Placa do cavalo</Field>
                </Grid>
                <Grid item xs={4}>
                  <Field>Tipo de carreta</Field>
                </Grid>
                <Grid item xs={4}>
                  <Field>CNPJ</Field>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={4}>
                  <Value>{caminhao?.veiculoCarreta2?.placa}</Value>
                </Grid>
                <Grid item xs={4}>
                  <Value>
                    {caminhao?.veiculoCarreta2?.tipoCarreta?.descricao}
                  </Value>
                </Grid>
                <Grid item xs={4}>
                  <Value>{caminhao.veiculoCarreta2?.frotista?.cnpj}</Value>
                </Grid>
              </Grid>
            </>
          )}

          {caminhao?.veiculoCarreta3 && (
            <>
              <Grid container>
                <Grid item xs={12}>
                  <Title>Dados carreta 3</Title>
                </Grid>

                <Grid item xs={4}>
                  <Field>Placa do cavalo</Field>
                </Grid>
                <Grid item xs={4}>
                  <Field>Tipo de carreta</Field>
                </Grid>
                <Grid item xs={4}>
                  <Field>CNPJ</Field>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={4}>
                  <Value>{caminhao?.veiculoCarreta3?.placa}</Value>
                </Grid>
                <Grid item xs={4}>
                  <Value>
                    {caminhao?.veiculoCarreta3?.tipoCarreta?.descricao}
                  </Value>
                </Grid>
                <Grid item xs={4}>
                  <Value>{caminhao.veiculoCarreta3?.frotista?.cnpj}</Value>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Modal>
      {loading && <LoadingBackdrop open={loading} color={colors.green} />}
    </>
  )
}

export default DetalhesCaminhao
